import { landxmlLoadingAtom } from '@/atoms';
import { LoadingBadge, LoadingBadgeKeyframes } from '@/components/ui/LoadingBadge';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

/**
 * Badge stack showing LandXML layers while they download and parse. One row per
 * layer; rows clear as soon as the layer's geometry reaches the scene, and a
 * failed load sticks around so the user can see why nothing appeared.
 *
 * Sits below the splat overlay in the same top-centre column and is
 * `pointer-events-none`, so it never steals interaction from the canvas.
 */
export const LandXMLLoadingOverlay = () => {
  const { t } = useTranslation('project');
  const loading = useAtomValue(landxmlLoadingAtom);
  const entries = Object.values(loading);
  if (entries.length === 0) return null;

  const labels = {
    fetching: t('landxmlLoader.fetching'),
    decoding: t('landxmlLoader.decoding'),
    failed: t('landxmlLoader.failed'),
  };

  return (
    <div className='pointer-events-none absolute top-16 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-1.5'>
      {entries.map((e) => (
        <LoadingBadge
          key={e.layerId}
          name={e.layerName}
          phase={e.phase}
          progress={e.progress}
          loadedBytes={e.loadedBytes}
          totalBytes={e.totalBytes}
          error={e.error}
          labels={labels}
        />
      ))}
      <LoadingBadgeKeyframes />
    </div>
  );
};
